var lineColorDictionaryCache = {};
var lineColorDictionary = (function() {
  var COLORIZABLE_RAIL_KINDS, ENDPOINT, KEY, SPECIAL_LINE_NAMES;
  var $ = window.$;

  class LineColorDictionary {

    /*
    * @param listOfLineNames Array 路線名の配列（一意の要素のみ）
    * @param cb Function(err, Object) コールバック
     */
    getColorsFor(listOfLineNames, cb) {
      var i, len, listToQuery, name, results, xhr;
      // そもそも路線名が無ければ、即終了
      if (0 >= listOfLineNames.length) {
        return typeof cb === "function" ? cb(null, {}) : void 0;
      }
      results = {};
      // キャッシュされている色を優先して、
      // それ以外はSolrに問い合わせる
      listToQuery = [];
      for (i = 0, len = listOfLineNames.length; i < len; i++) {
        name = listOfLineNames[i];
        if (lineColorDictionaryCache[name] != null) {
          results[name] = lineColorDictionaryCache[name];
        } else {
          listToQuery.push(name);
        }
      }
      // もしキャッシュから全部取れたら、
      // それらを返して終了！
      if (0 >= listToQuery.length) {
        return typeof cb === "function" ? cb(null, results) : void 0;
      }

      xhr = $.ajax(ENDPOINT, {
        cache: true,
        data: this._buildQueryFor(listToQuery),
        dataType: 'json'
      });
      xhr.done((data, ...args) => {
        var j, len1, lineColor, lineName, ref, ref1, row;
        ref1 = data != null ? (ref = data.response) != null ? ref.docs : void 0 : void 0;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          row = ref1[j];
          ({
            line_name: lineName,
            line_color_16: lineColor
          } = row);
          results[lineName] = lineColorDictionaryCache[lineName] = lineColor;
        }
        // ヒットしなかったものもキャッシュしておく（デフォルトのグレー）
        for (const name of listToQuery) {
          if (results[name] == null) {
            results[name] = lineColorDictionaryCache[name] = "#ccc"; // デフォルトのグレー
          }
        }
        return typeof cb === "function" ? cb(null, results) : void 0;
      });
      xhr.fail((...args) => {
        // ヒットしなかったものもキャッシュしておく（デフォルトのグレー）
        for (const name of listToQuery) {
          results[name] = lineColorDictionaryCache[name] = "#ccc"; // デフォルトのグレー
        }
        return typeof cb === "function" ? cb(null, results) : void 0; // void
      });
    }

    /*
    * 路線色を引ける路線名か確認
     */
    isColorizableRailKind(railKind) {
      return COLORIZABLE_RAIL_KINDS[railKind] === true;
    }

    
    // private

    _buildQueryFor(listOfLineNames) {
      return {
        q: `(line_name:${listOfLineNames.join(' OR ')})`,
        rows: listOfLineNames.length,
        fl: 'line_color_16,line_name,line_color_rgb',
        wt: 'json',
        key: KEY
      };
    }

  };

  ENDPOINT = process.env.REACT_APP_BASE_URL + "/search/rosen2/select/";

  KEY = "mapion_pc_chizumen";

  COLORIZABLE_RAIL_KINDS = {
    "JR": true,
    "飛行機": false,
    "バス": false,
    "徒歩": false,
    "私鉄": true,
    "移動": false,
    "その他": false
  };

  SPECIAL_LINE_NAMES = {
    'のぞみ': '東海道新幹線',
    'ひかり': '東海道新幹線',
    'こだま': '東海道新幹線',
    '踊り子': 'ＪＲ東海道本線',
    'スーパービュー踊り子': 'ＪＲ東海道本線'
  };

  /*
  * 検索用に路線名の整形
  * @param name String 整形したい路線名
   */
  LineColorDictionary.prototype.fixLineNameForColorSearch = (function() {
    var nameCache;
    nameCache = {};
    return function(name) {
      var fixedName, specialLineName;
      if (name == null) {
        return;
      }
      // もしキャッシュミスの場合は整形処理を実行する
      if (nameCache[name] == null) {
        fixedName = name;
        // ＪＲ山手線(内回り) -> ＪＲ山手線
        fixedName = fixedName.replace(/\([^)]*\)$/, "");
        // 踊り子105号 -> 踊り子
        fixedName = fixedName.replace(/\d+号$/, "");
        // 便名を路線名に変更してみる
        // 例：「のぞみ」や「ひかり」が実は「東海道新幹線」である
        if ((specialLineName = SPECIAL_LINE_NAMES[fixedName]) != null) {
          fixedName = specialLineName;
        }
        // キャッシュを更新する
        nameCache[name] = fixedName;
      }
      return nameCache[name];
    };
  })();

  return LineColorDictionary;

}).call(this);

export default lineColorDictionary;